module.exports = __webpack_public_path__ + "img/Enalp_120X35.3bae0f09.png";